import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DependentContainer, {
    dependentContainerFieldDefinitions,
    DependentContainerFieldsProps,
    DependentContainerProps,
} from "@store/Components/ContactUs/DependentContainer";
import React from "react";
import { connect } from "react-redux";

interface OwnProps extends WidgetProps {
    fields: {} & DependentContainerFieldsProps;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {
    const { dependentFieldKey, dependentFieldValue } = props.fields;

    return {
        meetRequirements:
            dependentFieldKey && dependentFieldValue
                ? state.components.contactUsForm.fieldValues[dependentFieldKey] === dependentFieldValue
                : true,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const DependentZone = ({ id, meetRequirements, fields: { ...otherFields } }: Props) => {
    const dependentContainerProps: DependentContainerProps = {
        ...otherFields,
        meetRequirements,
    };

    return (
        <DependentContainer {...dependentContainerProps}>
            <Zone zoneName="DependentZone" contentId={id} />
        </DependentContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(DependentZone),
    definition: {
        group: "Contact Us",
        displayName: "Dependent Zone",
        icon: "box",
        fieldDefinitions: [...dependentContainerFieldDefinitions],
    },
};

export default widgetModule;
